import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ShopPage from "./pages/ShopPage";
import Shop from "./pages/Shop";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import CategoriesPage from "./pages/CategoryPage";
import OrderStatus from "./pages/OrderStatus";
import CartPage from "./pages/CartPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import ReturnPage from "./pages/ReturnPage";
import UserDashboardPage from "./pages/UserDashboardPage";
import ProductDetails from "./pages/ProductDetails";
import UserOrders from "./pages/UserOrders";
import UserCheckout from "./pages/UserCheckout";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/orderstatus" element={<OrderStatus />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path="/terms-and-condition" element={<TermsPage />} />
        <Route path="/return-policy" element={<ReturnPage />} />
        <Route path="/user-dashboard" element={<UserDashboardPage />} />
        <Route path="/user-order" element={<UserOrders />} />
        <Route path="/user-checkout" element={<UserCheckout />} />
        <Route path="/shop/productdetails/:id" element={<ProductDetails />} />
      </Routes>
    </Router>
  );
}

export default App;